module.exports = __webpack_public_path__ + "img/logo.d59d0c80.svg";